import DefaultCarousel from './DefaultCarousel'

export * from './context'
export * from './hooks'

export type {DefaultCarouselProps} from './DefaultCarousel'
export default DefaultCarousel
